export const DEFAULT_IMPORT_DATABASE_FIELD_COUNT = 7;

export const databasesToContentId = {
  emptyDatabase: '000001',
  emptyDatabaseWithNewLineEnabled: '000002',
  databaseWithViews: '000003',
  databaseWithSampleCsvStructure: '000004',
  databaseWithSampleCsvStructureWithUgc: '000005',
  databaseWithContent: '000006',
  databaseForCopyAndPasteWithUserField: '000007',
  databaseWithBasicFields: '000008',
  databaseWithResolvedUserField: '000009',
  databaseWithSelfReferenceEntryLinkField: '000010',
};

export type DatabaseKey = keyof typeof databasesToContentId;
